import { RPCCacheStrategy } from "./types.js";
//#region src/hooks/useRPC/defaults.ts
var useRPCDefaultOpts = {
	cacheStrategy: RPCCacheStrategy.cacheFirst,
	callOnVisible: true,
	callOnVisibleTimeout: 6e4,
	fire: true,
	persistPreviousData: true,
	testData: void 0
};
/**
* This will require a ref to a html element being passed in so that the hook knows when the "thing" is in-view and
* should fire the RPC.
*
* This is more in the scope/responsibility of the view components though...
*/
/***
* When `data` is returned from this hook, it can be from the cache or the remote. We should return a `metadata` prop
* that has the information about the `data` and other useful information that might be needed in the future
*/
/***
* If the args are changing (ie: text input changing to make RPC search call), this option will debounce the args value
* so the RPC call isn't fired on every change
*/
/***
* // If no cache being rendered currently (it shows a blank page),
// we trigger the loading slow event.
if (config.loadingTimeout && !cache.get(key)) {
setTimeout(() => {
if (loading && isCallbackSafe())
getConfig().onLoadingSlow(key, config)
}, config.loadingTimeout)
}
*/
/*** react-query has this option - <ErrorBoundary /> catches and shows a retry option...
*
* // Handle error boundary
if (
result.isError &&
!result.isFetching &&
shouldThrowError(
defaultedOptions.suspense,
defaultedOptions.useErrorBoundary,
result.error
)
) {
throw result.error
}
*
*/
//#endregion
export { useRPCDefaultOpts };

//# sourceMappingURL=defaults.js.map